import { placeOffer, unplaceOffer } from "_graphql/kek/mutation/index.kek";
import {
  publishOffer,
  unpublishOffer,
} from "_graphql/visal/mutations/publish-offer";
import { useCallback, useState } from "react";

import { PopUp } from "components";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export default function PlaceUnplaceOfferContainer({
  open,
  setOpen,
  offerId,
  isPlaced,
  refetch,
  percentage,
  fac_offer,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  offerId: string;
  isPlaced: boolean;
  percentage: number;
  fac_offer: number;
  refetch?: () => void;
}) {
  // const { employee } = useCurrentUser();
  const [loading, setLoading] = useState(false);

  const [publishOfferMutation, { loading: publishing }] = useMutation(
    placeOffer,
    {
      onCompleted: () => {
        toast.success("Offer placed successfully");
        if (refetch) refetch();
        setOpen(false);
      },
      onError: (error) => {
        toast.error("Failed to place offer");
      },
      refetchQueries: ["GetKEKOffer"],
    }
  );

  const [unpublishOfferMutation, { loading: unpublishing }] = useMutation(
    unplaceOffer,
    {
      onCompleted: () => {
        toast.success("Offer unplaced successfully");
        if (refetch) refetch();
        setOpen(false);
      },
      onError: (error) => {
        toast.error("Failed to unplace offer");
      },
      refetchQueries: ["GetKEKOffer"],
    }
  );

  const handleSubmit = useCallback(
    async (values: any) => {
      try {
        setLoading(true);

        const input = {
          offerId: offerId,
          placedOffer: percentage,
        };

        console.log(values);

        if (isPlaced) {
          await unpublishOfferMutation({
            variables: input,
          });
        } else {
          await publishOfferMutation({
            variables: input,
          });
        }
      } catch (error) {
        toast.error(`Failed to ${isPlaced ? "unpublish" : "publish"} offer`);
      } finally {
        setLoading(false);
      }
    },
    [
      isPlaced,
      offerId,
      publishOfferMutation,
      unpublishOfferMutation,
      percentage,
    ]
  );

  const form = useFormik({
    initialValues: {
      placedOffer: percentage,
      offerId: offerId,
    },
    onSubmit: handleSubmit,
  });

  const renderActions = useCallback(
    () => (
      <>
        <button
          type="button"
          disabled={publishing || unpublishing}
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.handleSubmit)}
        >
          {publishing || unpublishing
            ? "Processing..."
            : isPlaced
              ? "Unplace"
              : "Place"}
        </button>
      </>
    ),
    [form.handleSubmit, isPlaced, unpublishing, publishing, percentage]
  );

  return (
    <PopUp
      variant="warning"
      title={`Are you sure you want to ${isPlaced ? "unplace" : "place"} this offer?`}
      description={
        isPlaced
          ? `This operation will recompute the values using ${fac_offer}% for Facultative Offer`
          : `Placed offer at ${percentage}% out of ${fac_offer}%. This operation would recompute the values for Facultative Offer`
      }
      open={open}
      setOpen={setOpen}
      renderActions={renderActions}
    />
  );
}
